import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { portfolio } from '../utility/portfolio'
import Fancybox from '../components/fancybox/Fancybox'
import { NavLink } from 'react-router-dom';
import GalleryPopup from '../components/portfolio/GalleryPopup';

function Portfolio() {

  return (
    <>
      <section className="section-breadcrumb">
        <div className="top_outline_01"></div>
        <div className="top_outline_02"></div>
        <div className="bottom_outline_01"></div>
        <div className="bottom_outline_02"></div>
        <div className="container-fulid">
          <div className="row">
            <div className="col-12">
              <div className="zx-breadcrumb padding-tb-100">
                <div className="banner mb-15 justify-content-center">
                  <h2>My Portfolio</h2>
                </div>
                <div className="entry-breadcrumb">
                  <h5>
                    <span>
                      <NavLink to="/">Home</NavLink>
                    </span>
                    <span> / </span>
                    <span className="post-page">
                      <NavLink to="/portfolio">My Portfolio</NavLink>
                    </span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-portfolio padding-tb-100">
        <div className="container">
          <Fancybox
            options={{
              Carousel: {
                infinite: true,
              },
            }}
          >
            <Fade triggerOnce direction='up' duration={1500} className="row">
              <>
                {
                  portfolio.map((data, index) => (
                    <GalleryPopup data={data} key={index} />
                  ))
                }
              </>
            </Fade>
          </Fancybox>
        </div >
      </section >
    </>
  )
}

export default Portfolio
